import { AnimatePresence, motion } from "motion/react";
import { ExternalLink, XIcon } from "lucide-react";
import { useEffect, useState } from "react";

const STORAGE_KEY = "retractation-banner-dismissed";

export function RetractationBanner() {
  const [isDismissed, setIsDismissed] = useState(true);

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY);
    setIsDismissed(dismissed === "true");
  }, []);

  const handleClose = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setIsDismissed(true);
  };

  return (
    <AnimatePresence>
      {!isDismissed && (
        <motion.div
          initial={{ y: -48, opacity: 0 }}
          animate={{ y: 0, opacity: 1, transition: { delay: 0.5, type: "spring" } }}
          exit={{ y: -48, opacity: 0 }}
          className="fixed top-0 left-0 right-0 z-[100] bg-indigo-600 text-white"
        >
          <div className="relative flex items-center justify-center px-10 py-2 text-sm">
            <div className="flex items-center justify-center gap-3">
              <span className="shrink-0 rounded-full bg-white/20 px-2 py-0.5 text-xs font-semibold uppercase tracking-wide">
                Nouveau
              </span>
              <span className="text-center">
                Mise en conformité avec la règlementation en matière de droit de rétractation (<a href="https://help.baback.co/en/articles/9853698" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 underline">voir le tutoriel<ExternalLink className="size-3" /></a>)
              </span>
            </div>
            <button
              type="button"
              onClick={handleClose}
              className="absolute right-2 shrink-0 cursor-pointer rounded p-1 transition-colors hover:bg-white/20"
              aria-label="Fermer"
            >
              <XIcon className="size-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
